<template>
    <fieldset :disabled="disabled">
        <b-card sub-title="Name">
            <b-form-group :state="firstNameState" :invalid-feedback="checkFirstNameValid">
                <label class="font-weight-bold">First Name</label>
                <b-form-input @keyup="changeDisabled" :state="firstNameState" v-model="fields.first_name" name="first_name" type="text" class="form-control input-lg"></b-form-input>
            </b-form-group>
            <b-form-group @keyup="changeDisabled" :state="lastNameState" :invalid-feedback="checkLastNameValid">
                <label class="font-weight-bold">Last Name</label>
                <b-form-input @keyup="changeDisabled" :state="lastNameState" v-model="fields.last_name" name="last_name" type="text" class="form-control input-lg"></b-form-input>
            </b-form-group>
            <b-form-group>
                <label class="font-weight-bold">Nickname or Other Preffered Name (optional)</label>
                <b-form-input v-model="fields.nickname" name="nickname" type="text" class="form-control input-lg"></b-form-input>
            </b-form-group>
        </b-card>
        <b-card class="mt-2" sub-title="Gender">
            <b-radio-group v-model="fields.gender">
                <b-radio value="M">
                    <font-awesome-icon icon="male"></font-awesome-icon> Male
                </b-radio>
                <b-radio value="F">
                    <font-awesome-icon icon="female"></font-awesome-icon> Female
                </b-radio>
            </b-radio-group>
        </b-card>
        <b-card class="mt-2" sub-title="Birthdate">
            <dt-picker @valid="changeValid" v-model="fields.birthdate"></dt-picker>
        </b-card>
        <b-card class="mt-2" sub-title="Allergies and/or Sensitivities">
            <textarea
                placeholder="(i.e. Peanuts)"
                class="form-control"
                :value="allergy_info"
                @input="(e) => updateAllergyInfo(e.target.value)"
            ></textarea>
        </b-card>
        <slot
            name="submitBtn" 
            :student="fields"
            :btnDisabled="btnDisabled"
        ></slot>
    </fieldset>
</template>
<script>
import dtPicker from "@/components/form/DateTimePicker.vue";
export default {
    props: ["student", "disabled"],
    components: { dtPicker },
    data() {
        return {
            fields: {
                first_name: "",
                last_name: "",
                nickname: "",
                gender: "",
                birthdate: "",
                personal_info: '{ "allergy_info": "" }',
                ...this.student
            }
        };
    },
    methods: {
        updateAllergyInfo(info) {
            this.fields.personal_info = JSON.stringify({ allergy_info: info });
        },
        textValid (text, name, max, min) {
            if (text.length > max) {
                return name + " is too long!";
            } else if (text.length > min) {
                return name + " is too short!"
            }
            return "";
        },
        changeValid (date_valid, date) {
            if (date_valid && date.length == 10) this.changeDisabled(); 
        },
        changeDisabled () {
            var disabled = !(this.firstNameState && this.lastNameState);
            this.$emit('disabled', disabled);
        }
    },
    computed: {
        allergy_info() {
            return this.fields.personal_info && JSON.parse(this.fields.personal_info).allergy_info;
        },
        btnDisabled() {
            var disabled = !(this.firstNameState && this.lastNameState);
            return this.disabled || disabled;
        },
        firstNameState () {
            return ((this.fields.first_name.length && this.fields.first_name.length <= 20) ? true : false);
        },
        lastNameState () {
            return (this.fields.last_name.length && this.fields.last_name.length <= 20) ? true : false;
        },
        checkFirstNameValid () {
            return this.textValid(this.fields.first_name, "First Name", 20, 0);
        },
        checkLastNameValid () {
            return this.textValid(this.fields.last_name, "Last Name", 20, 0);
        },
    },
    watch: {
        student(newStudent) {
            if (newStudent) {
                this.fields = { ...this.fields, ...newStudent };
                this.personal_info = JSON.parse(this.student.personal_info || "{}");
                this.allergy_info  = this.personal_info.allergy_info;
            }
        }
    }
}
</script>